import { ArrivalDeparture } from '../models/ArrivalDeparture';
import moment from "moment"
import { DateHelper } from '@/util/DateHelper';

export class ArrivalsDeparturesDay {
    dateId: string;
    arrivalsDepartures: ArrivalDeparture[]; 

    constructor(dateId: string) {
        this.dateId = dateId;
        this.arrivalsDepartures = [];
    }

    get date(){
        return new Date(this.dateId);
    }

    get sortedArrivalDepartureGroups(): ArrivalDeparture[][]{
        const sortedArrivalDepartures = ArrivalDeparture.sortByDate(this.arrivalsDepartures);
        return sortedArrivalDepartures.reduce(
            (arr: ArrivalDeparture[][], item) => {
                let arrivalDepartureGroup: ArrivalDeparture[] = arr
                .find(g => 
                    g.some(
                        (ad: ArrivalDeparture) => 
                            ad.arrivalDepartureType === item.arrivalDepartureType
                            && ad.placeId === item.placeId
                            && ad.transportName === item.transportName
                            && ad.atHHMM === item.atHHMM
                    )
                )
                if (arrivalDepartureGroup){
                    arrivalDepartureGroup.push(item);
                } else {
                    arrivalDepartureGroup = [item];
                    arr.push(arrivalDepartureGroup);
                }
                return arr;
            },
        []
        );
    }

    hasPassed(otherDateId){
        return new Date(this.dateId).getTime() < new Date(otherDateId).getTime();
    }

    get weekDayName(){
        return new DateHelper().formatDateWeekdayName(this.dateId);
    }

    get isToday(){
        const todayMoment = moment().startOf('day');
        const dateMoment = moment(this.dateId).startOf('day');
        return dateMoment.diff(todayMoment, 'days') === 0;
    }

    get isTomorrow(){
        const todayMoment = moment().startOf('day');
        const dateMoment = moment(this.dateId).startOf('day');
        return dateMoment.diff(todayMoment, 'days') === 1;
    }

    get isWithinPastOrComingWeek(){
        const todayMoment = moment().startOf('day');
        const dateMoment = moment(this.dateId).startOf('day');
        const dateDifference = dateMoment.diff(todayMoment, 'days')
        return dateDifference < 7 && dateDifference > -7;
    }

    get isWithinComingWeek(){
        const todayMoment = moment().startOf('day');
        const dateMoment = moment(this.dateId).startOf('day');
        const dateDifference = dateMoment.diff(todayMoment, 'days')
        return dateDifference < 7 && dateDifference >= 0;
    }

    get isWeekEndDay(){
        return this.date.getDay() === 6 || this.date.getDay() === 0;
    }

    isDuringDateDay(duringDate: string): boolean{
        const duringDateMoment = moment(duringDate).startOf('day');
        const dateMoment = moment(this.dateId).startOf('day');
        return duringDateMoment.format('YYYY-MM-DD') === dateMoment.format('YYYY-MM-DD');
    }

    public static sortByDate(arrivalDepartureDays: ArrivalsDeparturesDay[]): ArrivalsDeparturesDay[] {
        return arrivalDepartureDays.sort((a, b) => {
            if (a.date.getTime() < b.date.getTime()) {
                return -1;
            }
            if (a.date.getTime() > b.date.getTime()) {
                return 1;
            }
            return 0;
        })
    }
}

export default ArrivalsDeparturesDay;
